import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'
import * as GmapVue from 'gmap-vue'
import router from './router'
import store from './store'
import localforage from 'localforage'
import VueScrollTo from 'vue-scrollto'
import VueTheMask from 'vue-the-mask'
import VueMeta from 'vue-meta'
// import VueShowIfRoute from './vue-show-if-route'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration, CaptureConsole } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

if(process.env.VUE_APP_MODE && process.env.VUE_APP_MODE !== 'development') {
    if(process.env.VUE_APP_SENTRY_KEY) {
        Sentry.init({
            dsn: process.env.VUE_APP_SENTRY_KEY,
            environment: process.env.VUE_APP_MODE,
            release: process.env.PACKAGE_NAME + '@' + process.env.PACKAGE_VERSION,
            integrations: [
                new VueIntegration({
                    Vue,
                    tracing: true,
                    logErrors: true
                }),
                new Integrations.BrowserTracing(),
                new CaptureConsole({
                    levels: ['error']
                })
            ],
            tracesSampleRate: 1
        })
    } else {
        console.error('No Sentry key environment variable.')
    }
}

if(process.env.VUE_APP_MODE === 'production') {
    console.log = () => {}
}

Vue.config.productionTip = false

require('./styles/main.sass')

String.prototype.toPLN = function () {
    var parts = this.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return parts.join(',') + ' PLN'
}

Number.prototype.toPLN = function () {
    var parts = this.toFixed(2).toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return parts.join(',') + ' PLN'
}

Number.prototype.toDay = function () {
    let name
    switch(this) {
    case 0:
        name = 'Poniedziałek'
        break
    case 1:
        name = 'Wtorek'
        break
    case 2:
        name = 'Środa'
        break
    case 3:
        name = 'Czwartek'
        break
    case 4:
        name = 'Piątek'
        break
    }
    return name
}

// plugins
Vue.use(VueCompositionAPI)
Vue.use(VueScrollTo)
Vue.use(VueTheMask)
Vue.use(GmapVue, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        libraries: 'places'
    },
    installComponents: true
})
Vue.use(VueMeta, { refreshOnceOnNavigation: true })

// register global components
const globalComponents = require.context('./components/global', true, /\.vue$/i)
globalComponents.keys().map(key => {
    Vue.component(globalComponents(key).default.name ?? key.split('/').pop().split('.')[0], globalComponents(key).default)
})

// save vuex init state
const initialState = store.state
localforage.setItem('initialState', initialState)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// register service worker
if('serviceWorker' in navigator) {
    if (process.env.VUE_APP_MODE !== 'development') {
        navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`).then(reg => {
            reg.onupdatefound = () => {
                const installingWorker = reg.installing
                installingWorker.onstatechange = () => {
                    if(installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        window.location.reload()
                    }
                }
            }
        })
    }
}
